<template>
  <div>
    <van-tabbar route safe-area-inset-bottom active-color="#f44">
      <van-tabbar-item replace to="/" icon="home-o">首页</van-tabbar-item>
      <!-- <van-tabbar-item replace to="/category" icon="apps-o">分类</van-tabbar-item> -->
      <!-- <van-tabbar-item url="https://h5.daeyes.com.cn" icon="coupon-o">电影</van-tabbar-item> -->
      <van-tabbar-item url="https://film.daeyes.com" icon="coupon-o">
        <span>电影</span>
        <template #icon>
          <img src="../assets/image/movie.png" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item url="https://m.show.daeyes.com/" icon="coupon-o">
        <span>演出</span>
        <template #icon>
          <img src="../assets/image/show.png" alt="">
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/mine" icon="contact">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "Tabbar",
  data() {
    return {
    };
  }
};
</script>

<style lang="less" scoped>
</style>